import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import './index.css';
import {addTenantToPayload} from "../../utils";

class DeleteLibraryDialog extends Component {

    _deleteLibrary() {
        let libraryId = "";
        for (const library of this.props.libraries) {
            if (this.props.currentLibrary === library.name) {
                libraryId = library.id;
                break;
            }
        }

        const payload = {
            userId: this.props.userId,
            libraryId: libraryId
        };
        addTenantToPayload(payload, this.props.tenantId, this.props.snapTenantGuid);
        this.props.deleteLibrary(payload);
    }

    render() {

        return (
            <div id={"delete-library-dialog-container"}>
                <div id={"delete-library-dialog-wrapper"}>
                    <div className={"delete-library-dialog-header"}>
                        <h4>Confirm Delete Library</h4>
                    </div>
                    <div className={"delete-library-dialog-body"}>
                        <p>
                            Are you sure you want to delete &quot;{this.props.currentLibrary}&quot;?
                        </p>
                        <p>
                            This library will be deleted, along with any blocks inside it. This action cannot be undone.
                        </p>
                    </div>
                    <div className="delete-library-dialog-footer">
                        <Link to={`/${globalThis.location.search}`}>
                        <button className="btn-continue"
                                onClick={this._deleteLibrary.bind(this)}>CONFIRM DELETE</button>
                        </Link>
                        <Link to={`/${globalThis.location.search}`}>
                            <button className="btn-cancel">CANCEL</button>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}

DeleteLibraryDialog.propTypes = {
    libraries: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
    })).isRequired,
    currentLibrary: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
    tenantId: PropTypes.string,
    snapTenantGuid: PropTypes.string,
    deleteLibrary: PropTypes.func.isRequired
};

export default DeleteLibraryDialog
